export const rubrosHistoricos = [
    {
        "anio" : "2025",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/1Trim2025.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/2Trim2025.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/3Trim2025.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/4Trim2025.zip"
            }
        ]
    },
    {
        "anio" : "2024",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/1Trim2024.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/2Trim2024.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/3Trim2024.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/4Trim2024.zip"
            }
        ]
    },
    {
        "anio" : "2023",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/1Trim2023.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/2Trim2023.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/3Trim2023.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/4Trim2023.zip"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/1Trim2022.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/2Trim2022.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/3Trim2022.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/4Trim2022.zip"
            },
        ]
    },
    {
        "anio" : "2021",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/1Trim2021.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/2Trim2021.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/3Trim2021.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/4Trim2021.zip"
            }
        ]
    },
    {
        "anio" : "2020",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/1Trim2020.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/2Trim2020.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/3Trim2020.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/4Trim2020.zip"
            }
        ]
    },
    {
        "anio" : "2019",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/1Trim2019.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/2Trim2019.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/3Trim2019.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/4Trim2019.zip"
            }
        ]
    },
    {
        "anio" : "2018",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/1Trim2018.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/2Trim2018.rar"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/3Trim2018.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/4Trim2018.zip"
            }
        ]
    },
    {
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://consultapublicamx.inai.org.mx/vut-web/?idSujetoObigadoParametro=2131&idEntidadParametro=13&idSectorParametro=21"
            }
        ]
    },
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "https://dif.hidalgo.gob.mx/transparencia/zip/21Fracciones.zip"
            }
        ]
    }
]